import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import BlogThumbnail from "../components/BlogThumnail"; 
import imgg from "./content/pics/modernvanvas.jpeg"
import mys from "./content/pics/mysore.jpg";
import mum from "./content/pics/mumbai.jpeg";
import ord from "./content/pics/ordinary.jpeg";
import vol from "./content/pics/volun.jpg";
import fem from "./content/pics/feminism.png";
import que from "./content/pics/questions.jpg";
import BookReviews from "./MovieReviews";
import ShortStories from "./ShortStories";
import math from "./content/pics/Matheeww.jfif";
import anx from "./content/pics/anxiety.jpg";
import "./Articles.css"
import Na from "./content/pics/g.png"
const Articles = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState("all");

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };


  return (
    <div className="Full">
    <div className="all">
    <div className="filler"/>
      <div className="sidebar">
        <button className={`toggle-button ${isOpen ? "open" : ""}`} onClick={toggleSidebar}>
          <div className={`hamburger-icon ${isOpen ? "close" : ""}`}>
            <span className="line"></span>
            <span className="line"></span>
            <span className="line"></span>
          </div>
        </button>
        <Sidebar isOpen={isOpen} selectedItem={selectedItem} setSelectedItem={setSelectedItem} />
      </div>
      <div className="main-content">
        <div className="links-containerc">
          <a href="/">Home</a>
          <a href="/content">Content</a>
          <a href="/aboutus">About Us</a>
        </div>
        <div className="titles">
        <center><h2>Articles</h2></center>
        </div>
        <div className="blog-thumbnailsa">
        <div className="blog-thumbnail-containera">
  <a href="/ninhaB_VS_nanhaB">
    <BlogThumbnail
      imageSrc={Na}
      title="Nanna Bengaluru VS Ninna Bengaluru"
      description="No offense, but Bengaluru is a double edged sword. Does it embrace you, or suffocate you?"
    />
  </a>
</div>

<div className="second-blog-thumbnail-containera"> {/* New container for the second blog thumbnail */}
            <a href="/modernvanvas">
              <BlogThumbnail
                imageSrc= {imgg}
                title="Modern Vanvas"
                description="No offense, but you're getting sucked in an online black hole. 
                We've all gotten addicted to social media at some point to avoid facing reality. Is there any way out of it?"
              />
            </a>
          </div>

<div className="third-blog-thumbnail-containera"> {/* New container for the second blog thumbnail */}
  <a href="/mysore">
    <BlogThumbnail
      imageSrc= {mys}
      title="Mysore"
      description="No offense, but sometimes you need to run away from your problems."
    />
  </a>
</div>

<div className="third-blog-thumbnail-containera"> {/* New container for the second blog thumbnail */}
  <a href="/mumbai">
    <BlogThumbnail
      imageSrc= {mum}
      title="Mumbai-Travel Blog"
      description="No offense, but Mom and I in Mumbai; Unraveling the Charms of the City Together"
    />
  </a>
</div>

<div className="fourth-blog-thumbnail-containera"> {/* New container for the second blog thumbnail */}
  <a href="/ordinary">
    <BlogThumbnail
      imageSrc= {ord}
      title="Ordinary is Extraordinary"
      description="No offense, but ordinary is extraordinary."
    />
  </a>
</div>
<div className="fourth-blog-thumbnail-containera"> {/* New container for the second blog thumbnail */}
  <a href="/ordinary">
    <BlogThumbnail
      imageSrc= {vol}
      title="Being the change at U and I"
      description="No offense, but volunteering can truly be a life-changing experience"
    />
  </a>
</div>

<div className="fourth-blog-thumbnail-containera"> {/* New container for the second blog thumbnail */}
  <a href="/feminism">
    <BlogThumbnail
      imageSrc= {fem}
      title="The future is not female"
      description="No offense, but no gender can be the future."
    />
  </a>
</div>

{/* <div className="fourth-blog-thumbnail-containera">
          <a href="/questions">
              <BlogThumbnail
                imageSrc={que}
                title="Let's talk about sex."
                description="No offense, but these questions need to be answered."
              />
            </a>
          </div>  */}
          <div className="fourth-blog-thumbnail-containera">
          <a href="/mathew">
              <BlogThumbnail
                imageSrc={math}
                title="Matthew Perry: The Laughter, The Struggles, and The Legacy of Chandler Bing"
                description="."
              />
            </a>
          </div> 

          <div className="fourth-blog-thumbnail-containera">
          <a href="/anxiety">
              <BlogThumbnail
                imageSrc={anx}
                title="Let's talk about mental health."
                description="No offense, but anxiety is REAL."
              />
            </a>
          </div> 
 
        
      </div>
    </div>
    </div>
    </div>
  );
};

export default Articles;


